module.exports = __webpack_public_path__ + "static/img/SafariWorld-zh.06ffafc0.png";